import { explicitMaybe, stringLiteral } from '@execonline-inc/decoders';
import { paginationMetadataDecoder } from '@execonline-inc/resource';
import { Decoder, array, dateISO, field, number, oneOf, string, succeed } from 'jsonous';
import { resourceDecoder, resourceWithMetadataDecoder } from '../Resource/Decoders';
import { Group, GroupResource, GroupStatus, GroupsResource, Participant } from './Types';

export const participantDecoder: Decoder<Participant> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string));

export const groupStatusDecoder: Decoder<GroupStatus> = oneOf([
  stringLiteral<GroupStatus>('Active'),
  stringLiteral<GroupStatus>('Inactive'),
]);

export const groupDecoder: Decoder<Group> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('organization', field('organization', string))
  .assign('status', field('status', groupStatusDecoder))
  .assign('lastLoginAt', field('last_login_at', explicitMaybe(dateISO)))
  .assign('totalEnrollmentsCount', field('total_enrollments_count', number))
  .assign('participants', field('participants', explicitMaybe(array(participantDecoder))));

export const groupResourceDecoder: Decoder<GroupResource> = resourceDecoder(groupDecoder);

export const groupResourcesDecoder: Decoder<GroupsResource> = resourceWithMetadataDecoder(
  array(groupResourceDecoder),
  paginationMetadataDecoder,
);
